@if (!webCameraError) {
  @if (showLiveness) {
    <p class="instructions-container" [ngClass]="{'liveness-completed': livenessCompleted === true}" i18n>
      {{instructions}}
    </p>
    <div class="liveness-container">
      <div class="video-wrapper">
        <video #video id="webcam" autoplay muted [hidden]="livenessCompleted"  playsinline> </video>
        <img class="headshoot-photo" src={{finalPhoto}} alt="headshot" photo [hidden]="!livenessCompleted">
        @if (showOk) {
          <svg  class="success-svg" viewBox="0 0 100 100">     
            <circle cx="50" cy="50" r="45" fill="none" stroke="#4CAF50" stroke-width="2"
              stroke-dasharray="283" stroke-dashoffset="283">
              <animate attributeName="stroke-dashoffset" from="283" to="0" dur="0.5s" fill="freeze"/>
            </circle>   
            <path d="M25 52l12 12 35-35" fill="none" stroke="#4CAF50" stroke-width="4"
              stroke-dasharray="67" stroke-dashoffset="67" stroke-linecap="round">
              <animate attributeName="stroke-dashoffset" from="67" to="0" dur="0.3s" begin="0.5s" fill="freeze"/>
            </path>
          </svg>
        }
      </div>
      <div id="fallback" class="fallback" style="margin-top: 15px;">
        <p i18n>Having trouble? <a href="#" (click)="activateManualMode($event)">Click here to take your photo manually</a>.
        </p>
      </div>
    </div>
    <div class="button-group-responsive" style="margin-top: 15px;">
      <button class="button button-primary" (click)="back()" i18n="Button label">
        BACK
      </button>
      @if (!isDetecting) {
        <button class="button button-primary" (click)="startDetection()" i18n="Button label">
          START
        </button>
      }
      @if (livenessCompleted) {
        <button class="button button-primary" style="background-color: green;" (click)="submitPhoto()" i18n="Button label">
          SUBMIT
        </button>
      }
    </div>
  } @else {
      <app-liveness-fb  (finalPicture)="processImage($event)"></app-liveness-fb>
  }
}

@if (webCameraError) {
  <div class="camera-error-container">
    @if (cameraErrorName === 'NotAllowedError') {
      <div class="camera-error-help">
        <h2 i18n >Camera Permission Denied</h2>
        <p i18n>In your favorite search engine you can search for the following: </p>
        <ul class="feedback-tips">
          <li>
            <span class="list-icon"><mat-icon color="primary">check_circle</mat-icon></span>
            <p i18n><strong>Google Chrome: </strong> How to enable camera permissions for Google Chrome</p>
          </li>
          <li>
            <span class="list-icon"><mat-icon color="primary">check_circle</mat-icon></span>
            <p i18n><strong>Safari: </strong> How to enable camera permissions for Safari</p>
          </li>
          <li>
            <span class="list-icon"><mat-icon color="primary">check_circle</mat-icon></span>
            <p i18n><strong>Microsoft Edge: </strong> How to enable camera permissions for Microsoft Edge</p>
          </li>
          <li>
            <span class="list-icon"><mat-icon color="primary">check_circle</mat-icon></span>
            <p i18n><strong>Firefox: </strong> How to enable camera permissions for Firefox</p>
          </li>
        </ul>
        <p i18n >Once you have solved the problem, click <strong> RETRY</strong> or <strong>EXIT</strong> to close the session.</p>
        <p i18n class="warning-message">
          <mat-icon class="warning-icon">warning</mat-icon>
          Do not reload this page.
        </p>
      </div>
    }
    @if (cameraErrorName === 'NotFoundError') {
      <div class="camera-error-help">
        <h2 style="color: #d9534f;text-align: center;" i18n>Camera Not Found</h2>
        <p i18n>The camera could not be accessed. This may be due to one of the following reasons:</p>
        <ol>
          <li i18n><strong>No camera is connected to the device:</strong> Ensure that your device has a built-in camera or that an external camera is properly connected.</li>
          <li i18n><strong>The camera is disabled at the operating system level:</strong> 
            <ul>
              <li><strong>Windows:</strong> Check <em>Settings > Privacy > Camera</em> and ensure camera access is enabled for apps and browsers.</li>
              <li><strong>macOS:</strong> Check <em>System Preferences > Security & Privacy > Camera</em> and ensure your browser has permission to access the camera.</li>
              <li><strong>Linux:</strong> Verify that the camera device is recognized (e.g., using <code>lsusb</code> or <code>v4l2</code> commands) and permissions are set correctly.</li>
            </ul>
          </li>
      
          <li i18n><strong>The camera is in use by another application:</strong> Close any applications (e.g., Zoom, Teams, Skype) that might be using the camera and try again.</li>
          
          <li i18n><strong>Camera drivers are not installed or are corrupted:</strong> Reinstall or update the camera drivers on your system to ensure the device is recognized.</li>
      
          <li i18n><strong>Browser restrictions:</strong> Some browsers may block access to the camera due to security policies. Ensure that your site is served over HTTPS and check your browser settings for any blocked permissions.</li>
        </ol>
        <p style="font-weight: bold; color: #d9534f; margin-top: 20px;" i18n>
          Note: The steps and behavior described above may vary depending on the version of your operating system or browser. For the most accurate guidance, refer to your system or browser's official documentation.
        </p>
        <p i18n>Once you have solved the problem, click <strong> RETRY</strong> or <strong>EXIT</strong> to close the session.</p>     
      
        <p i18n>If the problem persists, please try restarting your device or testing with another camera.</p>
        <p i18n class="warning-message">
          <mat-icon class="warning-icon">warning</mat-icon>
          Do not reload this page.
        </p>
      </div>
    }
    <div class="button-group-responsive">
      <button class="button button-primary" (click)="retry()" i18n="Button label">
        RETRY
      </button>
      <button class="button button-primary" (click)="exitApp()" i18n="Button label">
        EXIT
      </button>
    </div>
  </div>
}

@if (displaySpinner) {
  <div class="progressSpinner">
    <mat-spinner [diameter]="300" color="primary"></mat-spinner>
    <div class="spinner-warning">
      <p i18n>Please do not refresh, click the browser back button, or close your browser.</p>
    </div>
  </div>
}